import { TFunction } from 'i18next'
import { z } from 'zod'

import { isImpersonating } from '@/utils/auth'

export const makeImpersonationSchema = (t: TFunction<['user-panel']>) =>
  z.object({
    email: z
      .string()
      .trim()
      .min(1, t('user-panel:impersonation.validation.emailRequired'))
      .pipe(z.email(t('user-panel:impersonation.validation.emailInvalid'))),
  })

export type ImpersonationFormValues = z.infer<ReturnType<typeof makeImpersonationSchema>>

type ImpersonationUserData = {
  isSupport?: boolean
  user?: { role?: string }
}

/**
 * Administrators, and Managers flagged `isSupport` (from GET /manager), can impersonate — never
 * while already impersonating, since that would overwrite the parked original session.
 */
export const canImpersonate = (userData: ImpersonationUserData) => {
  if (isImpersonating()) return false

  const role = userData?.user?.role
  return role === 'Administrator' || (role === 'Manager' && userData.isSupport === true)
}
